import { __rest } from 'tslib';
import React from 'react';
import { useColor } from '../../theme/Theme.js';
import { Icon } from '../Icon.js';

const Edit = React.forwardRef((_a, ref) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const _color = useColor(color);
    return (React.createElement(Icon, Object.assign({ "data-testid": 'tend-ui-edit-icon' }, props, { ref: ref, color: _color }),
        React.createElement("svg", { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'currentColor', xmlns: 'http://www.w3.org/2000/svg' },
            React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M16.5858 2.99997C17.3669 2.21892 18.6332 2.21892 19.4142 2.99997L21 4.58576C21.7811 5.36681 21.7811 6.63314 21 7.41419L7.70713 20.7071C7.57897 20.8352 7.41839 20.9262 7.24256 20.9701L3.24256 21.9701C2.90178 22.0553 2.54129 21.9555 2.29291 21.7071C2.04453 21.4587 1.94468 21.0982 2.02988 20.7574L3.02988 16.7574C3.07384 16.5816 3.16476 16.421 3.29291 16.2929L16.5858 2.99997ZM5.70711 16.7071L7.2929 18.2929L16.5858 8.99996L15 7.41418L5.70711 16.7071ZM19.5858 5.99997L18 7.58575L16.4142 5.99996L18 4.41418L19.5858 5.99997Z', fill: 'currentColor' }))));
});
Edit.displayName = 'Edit';

export { Edit };
//# sourceMappingURL=Edit.js.map
